import { MiddleMegaMenuExperienceFragment } from './MiddleMegaMenuExperienceFragment';

export default MiddleMegaMenuExperienceFragment;
